import { noop } from 'lodash/fp';
import React from 'react';

import { useWindowResize } from '../../../../hooks/useWindowResize';
import { CalculatorWithKnownType } from '../../../shared/calculator/Calculator';
import { newCalculatorField } from '../../../shared/calculator/constants';
import { CalculatorFieldTypeUI } from '../store';
import styles from './CalculatorManager.module.scss';

const { lightGrey } = styles;

interface CalculatorFieldTypePreviewProps {
    calculatorField: CalculatorFieldTypeUI;
}

export const CalculatorFieldTypePreview: React.FC<CalculatorFieldTypePreviewProps> = ({ calculatorField }) => {
    const { includeOutput, includeOther, includeGracePeriod } = calculatorField;
    const [screenWidth] = useWindowResize();
    return (
        <div className={styles.previewWrapper}>
            <CalculatorWithKnownType
                value={[newCalculatorField()]}
                updateValue={noop}
                isEditing
                calculatorFieldType={calculatorField}
                width={screenWidth * 0.7}
                borderColor={lightGrey}
                showOutputField={includeOutput === 1}
                showGracePeriod={includeGracePeriod === 1}
                includeFreeTextOption={includeOther === 1}
                minHeight='0'
            />
        </div>
    );
};
